import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Tonality } from '../components/Tonality';
import { Vision } from '../components/Vision';
export function VisionPage() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  return <div className="pt-20" data-id="element-570" data-mp="1x7eanqqt5zao">
      <Tonality data-id="element-571" data-mp="1x8pfltvzpd3d" />
      <Vision data-id="element-572" data-mp="1x990njgxshlm" />
    </div>;
}